"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var exceptions_1 = require("rest-resource/dist/exceptions");
exports.ValidationError = exceptions_1.ValidationError;
var number_1 = require("../number");
var date = tslib_1.__importStar(require("date-fns"));
function extendValidators(BaseResourceClass, newValidators) {
    return Object.assign({}, BaseResourceClass.validators, newValidators);
}
exports.extendValidators = extendValidators;
function isRequired(field) {
    return function (value, resource, ValidationError) {
        if (!value) {
            throw new ValidationError(field, 'A value is required');
        }
    };
}
exports.isRequired = isRequired;
function isValidCurrency(field) {
    return function (value, resource, ValidationError) {
        if (isNaN(Number(value))) {
            throw new ValidationError(field, value + " is not a valid currency format");
        }
        if (number_1.decimalPlaces(value) > 2) {
            throw new ValidationError(field, number_1.decimalPlaces(value) + " decimal places is not a valid currency format (received " + value + ")");
        }
    };
}
exports.isValidCurrency = isValidCurrency;
function isValidDate(field) {
    return function (value, instance, ValidationError) {
        if (!date.isValid(new Date(value))) {
            throw new ValidationError('date');
        }
    };
}
exports.isValidDate = isValidDate;
function jeDebitsEqualCredits() {
    return function (value, instance, ValidationError) {
        if (instance.inGL() && !number_1.sumsToZero([value, instance.get('credits_decimal')])) {
            throw new ValidationError('debits_decimal', 'Debits must offset credits!');
        }
    };
}
exports.jeDebitsEqualCredits = jeDebitsEqualCredits;
//# sourceMappingURL=validation.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/util/resources/validation.js
// module id = U4H/
// module chunks = 0